<div class="layout-menu-container flex">

  <div
    [class.minimized-first-level]="minimizedFirstLevel"
    class="flex flex-column h-full first-level"
  >
    <div
      (mouseenter)="onFirstLevelMouseEnter()"
      (mouseleave)="onFirstLevelMouseLeave()"
      class="pt-4"
    ></div>
    <div
      *ngFor="let item of items"
      [routerLink]="item.routerLink"
      [class.minimized-menu-item]="minimizedFirstLevel"
      [class.expanded-menu-item]="!minimizedFirstLevel"
      [class.menu-item-active]="selectedFirstLevelItem === item && selectedSecondLevelItem"
      (mouseenter)="onFirstLevelMouseEnter()"
      (mouseleave)="onFirstLevelMouseLeave()"
      routerLinkActive="menu-item-active"
      [routerLinkActiveOptions]="item.routerLinkActiveOptions ? item.routerLinkActiveOptions: {exact: false}"
    >
      <div
        (click)="selectFirstLevelItem(item, $event)"
        class="flex justify-content-between align-items-center menu-item cursor-pointer"
      >
        <div class="flex align-items-center">
          <i class="pi {{item.icon}} py-1" style="font-size: 17px"></i>
          <p [hidden]="minimizedFirstLevel" class="ml-3 mb-0" style="font-size: 16px">{{item.label | transloco}}</p>
        </div>
        <div [hidden]="!item.items || minimizedFirstLevel" class="align-items-center">
          <i class="pi pi-chevron-right mr-2"></i>
        </div>
      </div>
    </div>
    <div
      (mouseenter)="onFirstLevelMouseEnter()"
      (mouseleave)="onFirstLevelMouseLeave()"
      class="flex-grow-1 flex flex-column justify-content-end"
    >
      <div class="mb-6 pb-6 px-4" [class.opacity-0]="minimizedFirstLevel" [class.w-0]="minimizedFirstLevel">
        <img
          src="assets/logo/logotipo_nealis_tech.svg"
          alt="Nealis Tech"
        >
      </div>
    </div>
  </div>

  <div *ngIf="minimizedFirstLevel && fadeInFlag" class="flex-grow-1 fadein">
    <p class="text-center text-xl py-4 mb-0 mt-2">
      <i [class]="selectedFirstLevelItem.icon" class="mr-1" style="font-size: 18px;"></i>
      {{selectedFirstLevelItem.label | transloco}}
    </p>
    <div class="flex justify-content-center">
      <hr class="mt-0" style="width: 80%;">
    </div>
    <div *ngFor="let item of selectedFirstLevelItem.items">
      <div
        (click)="selectSecondLevelItem(item, $event)"
        [routerLink]="item.routerLink"
        routerLinkActive="menu-item-active expanded-menu-item"
        class="flex justify-content-between align-items-center menu-item cursor-pointer"
      >
        <div class="flex align-items-center">
          <p class="ml-1 mb-0" style="font-size: 16px">{{item.label | transloco}}</p>
        </div>
        <div *ngIf="item.items" class="flex align-items-center">
          <i class="pi pi-chevron-right mr-2"></i>
        </div>
      </div>
    </div>
  </div>

</div>
